import { render, staticRenderFns } from "./TemplateEntitlementList.vue?vue&type=template&id=89c618c4&scoped=true&"
import script from "./TemplateEntitlementList.vue?vue&type=script&lang=js&"
export * from "./TemplateEntitlementList.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEntitlementList.vue?vue&type=style&index=0&id=89c618c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c618c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89c618c4')) {
      api.createRecord('89c618c4', component.options)
    } else {
      api.reload('89c618c4', component.options)
    }
    module.hot.accept("./TemplateEntitlementList.vue?vue&type=template&id=89c618c4&scoped=true&", function () {
      api.rerender('89c618c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/TemplateEntitlementList.vue"
export default component.exports